import React from "react";
import { useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import Router from "./Router/route";
import { ToastProvider } from "./Components/Toast";

function App() {
  useEffect(() => {
    document.title = "Nasa Space App";
  }, []);
  return (
    <>
      <div className="flex flex-col w-full h-screen bg-white font-[500]">
        <ToastProvider>
          <BrowserRouter>
            <Router />
          </BrowserRouter>
        </ToastProvider>
      </div>
    </>
  );
}

export default App;
